import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2 titleWords text-2xl" }, "EGGZ Rates", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FixedScheduleDisplay = _resolveComponent("FixedScheduleDisplay")!

  return (_ctx.parseRewardType(_ctx.farmReward) === 'variable')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_FixedScheduleDisplay, {
          key: _ctx.farmReward,
          class: "ml-1",
          schedule: _ctx.reward.fixedRate.promisedSchedule
        }, null, 8, ["schedule"])
      ]))
}